export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function nextFrame() {
  return new Promise(requestAnimationFrame);
}

export async function fetchUrl(url) {
  const response = await fetch(url);
  return await response.text();
}
